<div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div>
<div *ngIf="detailMode; then showSpan else showInput"></div>
<ng-template #showInput>
    <input [type]="tipo" #field [ngClass]="(readOnly ? 'form-control disabled' : 'form-control')"
        [id]="(id === null ? name : id)" [name]="name" [value]="value" [attr.maxlength]="maxSize" [disabled]="readOnly"
        (input)="changeValue($event)" [placeholder]="placeholder" />
    <app-input-feedback [hidden]="isValidInput()" [feedbackMessage]="spanRequired"></app-input-feedback>
</ng-template>
<ng-template #showSpan>
    <span type="text" #field [id]="(id === null ? name : id)">
        {{value}}
    </span>
    <hr *ngIf="includeLabel" />
</ng-template>
